import { HTMLAttributes, Ref, createElement, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { FontVariant, getElementName, textTypography } from '@utils';

import { useResponsiveTextVariant } from './useResponsiveTextVariant';

export interface TextProps extends HTMLAttributes<HTMLHeadingElement> {
  variant?:
    | FontVariant
    | {
        sm?: FontVariant;
        md?: FontVariant;
        lg?: FontVariant;
      };
}

export const Text = forwardRef<HTMLElement, TextProps>(
  ({ variant = 'body-16/r', className, children, ...rest }, ref: Ref<HTMLElement>) => {
    const { sizeVariant, weightVariant } = useResponsiveTextVariant(variant);
    const textVariant = textTypography({
      variant: sizeVariant,
      weight: weightVariant,
    });

    const newClassName = twMerge(textVariant, className);

    const elementName = getElementName(sizeVariant);

    return createElement(
      elementName,
      {
        className: newClassName,
        ref,
        ...rest,
      },
      children,
    );
  },
);

Text.displayName = 'Text';
